import { createUseStyles } from '@glu/theming';

const styles = {
  amountField: {
    '&::-ms-clear': {
      display: 'none'
    }
  }
};

export default createUseStyles(styles);
